import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Users, Share2 } from "lucide-react";

const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4 animate-fade-in">
            Unlock Exclusive Networking Opportunities
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: "0.2s" }}>
            Joining our network means gaining access to a wealth of resources and connections. Expand your reach and grow your business with our tailored opportunities.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <Card className="hover:shadow-xl transition-all duration-300 animate-fade-in" style={{ animationDelay: "0.3s" }}>
            <CardHeader>
              <div className="bg-primary/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <Calendar className="h-6 w-6 text-primary" />
              </div>
              <CardTitle>Weekly Meetings</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Rotating sessions with spotlight presentations and breakout discussions. Each week includes a member elevator pitch round, where members can share updates, make special requests, or give shout-outs to fellow members.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="hover:shadow-xl transition-all duration-300 animate-fade-in" style={{ animationDelay: "0.4s" }}>
            <CardHeader>
              <div className="bg-primary/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <Users className="h-6 w-6 text-primary" />
              </div>
              <CardTitle>Networking Events</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Meet like-minded professionals and expand your network at our regular networking events designed to foster meaningful business relationships.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="hover:shadow-xl transition-all duration-300 animate-fade-in" style={{ animationDelay: "0.5s" }}>
            <CardHeader>
              <div className="bg-primary/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <Share2 className="h-6 w-6 text-primary" />
              </div>
              <CardTitle>Referral Program</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Boost your visibility with trusted referrals from fellow members. Our proven referral system helps drive quality leads to your business.
              </CardDescription>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
